"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresOrdersReducer = void 0;
var _immer = require("immer");
var actions = _interopRequireWildcard(require("../actions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var initialState = {
  openOrders: [],
  inactiveOrders: [],
  filledOrders: [],
  fetchingOpenOrders: false,
  fetchingInactiveOrders: false,
  fetchingFilledOrders: false,
  activePages: {}
};
var futuresOrdersReducer = exports.futuresOrdersReducer = function futuresOrdersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  return (0, _immer.produce)(state, function (draft) {
    switch (type) {
      case actions.REQUEST_FUTURES_OPEN_ORDERS:
        draft.fetchingOpenOrders = true;
        break;
      case actions.RECEIVE_FUTURES_OPEN_ORDERS:
        draft.fetchingOpenOrders = false;
        draft.openOrders = payload;
        break;
      case actions.REQUEST_FUTURES_INACTIVE_ORDERS:
        draft.fetchingInactiveOrders = true;
        break;
      case actions.RECEIVE_FUTURES_INACTIVE_ORDERS:
        draft.fetchingInactiveOrders = false;
        draft.inactiveOrders = payload;
        break;
      case actions.RESET_FUTURES_ACTIVE_PAGE:
        if (payload.componentId) {
          delete draft.activePages[payload.componentId];
        }
        break;
      case actions.REQUEST_FUTURES_FILLED_ORDERS:
        draft.fetchingFilledOrders = true;
        break;
      case actions.RECEIVE_FUTURES_FILLED_ORDERS:
        draft.fetchingFilledOrders = false;
        draft.filledOrders = payload;
        break;
      case actions.RECEIVE_FUTURES_ORDER_UPDATE:
        {
          var openIndex = draft.openOrders.findIndex(function (o) {
            return o.OrderId === payload.OrderId;
          });
          if (payload.OrderState === 'Working') {
            if (openIndex === -1) {
              draft.openOrders.push(payload);
            } else {
              draft.openOrders[openIndex] = payload;
            }
          } else if (['Rejected', 'Canceled', 'FullyExecuted'].includes(payload.OrderState)) {
            if (openIndex !== -1) {
              draft.openOrders.splice(openIndex, 1);
            }
            var filledIndex = draft.inactiveOrders.findIndex(function (o) {
              return o.OrderId === payload.OrderId;
            });
            if (filledIndex === -1) {
              draft.inactiveOrders.push(payload);
            } else {
              draft.inactiveOrders[filledIndex] = payload;
            }
          }
          break;
        }
      default:
        return state;
    }
  });
};